export class ModificaPF {
    
  dataInstallazioneRouter!: Date;
  dataAttivazione!: Date;
  stato!: String;

}
  